import React from 'react';
import { XR } from '..';
export function SectionCard(_a) {
    var children = _a.children;
    return (React.createElement(XR.Section, null,
        React.createElement(XR.Card, null, children)));
}
